export enum SortPatternEnum {
  None = 0,
  Sort19,
  Sort91,
  SortAZ,
  SortZA,
}

